import { createContext, useState } from "react";

export const AccountContext = createContext();
const AccountProvider = ({children}) =>{
    const [showNewServerConnectionWindow,setShowNewServerConnectionWindow] = useState(false);
    const [selectedEditTenantAdminProfile,setSelectedEditTenantAdminProfile] = useState(null);
    const [selectedDeleteTenantAdminProfile,setSelectedDeleteTenantAdminProfile] = useState(null);
    return(
        <AccountContext.Provider value={{
            showNewServerConnectionWindow,
            setShowNewServerConnectionWindow,
            selectedEditTenantAdminProfile,
            setSelectedEditTenantAdminProfile,
            selectedDeleteTenantAdminProfile,
            setSelectedDeleteTenantAdminProfile
        }}>{children}</AccountContext.Provider>
    );
};
export default AccountProvider;